import { Api } from '@axiom/ui';
import type { Account } from '@axiom/validation';

import { EnvUtil } from '../utils/env-util';

export type ReadAccountsPayload = {
  data: Account[];
  meta: { currentPage: number; pageCount: number; resultCount: number };
};

class AccountApiClass extends Api {
  constructor() {
    super({
      domain: EnvUtil.apiAltUrl,
    });
  }

  readAccounts(filterMeta?: { search?: string; page?: number }) {
    return super.read<ReadAccountsPayload>({
      endpoint: `/accounts`,
      method: 'GET',
      query: filterMeta,
    });
  }
}

export const AccountApi = new AccountApiClass();
